@import "../../public/product-card/general-search-result-product-styles";
@import "../../../../result-page/new-result-cards/public/basic-card/uiaas-search-result-basic-v2.scss";

.faq-premium-tag {
  margin-bottom: 5px;
}
